<template>

  <div class="modal-card" id="settings-panel">
    <b-loading :is-full-page="false" :active.sync="isLoading" ></b-loading>
    <header class="modal-card-head">
      <p class="modal-card-title">Configuración del Proyecto</p>
    </header>

    <section class="modal-card-body">
    <!--  <b-tabs v-model="activeTab">
        <b-tab-item label="General"> -->
          <div class="columns is-desktop">
            <div class="column is-two-thirds">
              <b-field label="Nombre de tu proyecto" >
                <b-input :value="name" v-model="name"></b-input>
              </b-field>
              <b-field label="Descripción">
                <b-input :value="description" v-model="description"></b-input>
              </b-field>
              <b-field label="Tipo">
                <p class = "type">{{project.config.type}}</p>
              </b-field>

              <!-- public/private -->
              <b-field label = "Compartir" v-if="isAuthenticated">
                <div class = "horizontal-chooser">
                  <b-radio-button v-model="is_public" class = "left" :native-value="true" type="is-success">
                    <span>Público</span>
                  </b-radio-button>

                  <b-radio-button v-model="is_public" class = "right" :native-value="false" type="is-success">
                    <span>Privado</span>
                  </b-radio-button>
                </div>
              </b-field>

              <!-- clase -->
              <b-field label = "Clase" id="clase" v-if="isAuthenticated">
                <div>
                  <ClassroomSelectList @input2="selectClassroom"  :currentClassroom="selectedClassroom" :user="this.$store.state.user" :alwaysDisplay="false" headerText="Añadir proyecto a la clase:"></ClassroomSelectList>
                  <p>
                    Si tu clase no aparece aquí, tienes que añadirla primero en tu <router-link :to="{ name: 'User'}" target="_blank"> configuración de usuario </router-link>
                  </p>
                  <div v-if="selectedClassroom" class="message is-warning">
                    <div class="message-body aviso-clase" v-if="isClassroomStudent">
                      Al agregar un proyecto a una clase el profesor de la clase puede verlo.
                    </div>
                    <div class="message-body aviso-clase" v-else>
                      Al agregar un proyecto a una clase de la que eres profesor, todos los alumnos de esa clase lo pueden ver.
                    </div>
                  </div>

                  <!--
                  <div class="field" style="margin-top:2vh; min-height:2em">
                      <b-switch v-model="is_shared_with_teacher" v-if="selectedClassroom">
                          {{ is_shared_with_teacher_string }}
                      </b-switch>
                  </div>
                  -->
                </div>
              </b-field>
            </div>

            <!-- screenshot area -->
            <div class="column">
              <div id="previewer-container">
                <EditorScreenshotSaver :project = "project" />
              </div>
            </div>
          </div>
    </section>

    <footer class="modal-card-foot">
      <button class = "btn" v-on:click = "hideSetings">Cancelar</button>
      <button class = "btn btn-bg-colored" v-on:click = "saveAndClose">Guardar</button>
    </footer>
  </div>
</template>

<script>
import ClassroomSelectList from '../UI/ClassroomSelectList'
import EditorScreenshotSaver from './EditorScreenshotSaver'

export default {
  name: 'EditorSettings',
  props: {
    project: Object
  },
  components: {
    ClassroomSelectList,
    EditorScreenshotSaver
  },
  computed: {
    projectInfo () {
      // return this.$store.state.project[this.projectId]
      return this.project
    },
    is_public_string () {
      // return this.is_public ? 'Proyecto Público' : 'Proyecto Privado'
      return 'Proyecto Público'
    },
    is_shared_with_teacher_string () {
      return this.is_shared_with_teacher ? 'Compartido con el profesor' : 'Privado: NO visible al profesor'
    },
    isAuthenticated () {
      return this.$store.getters['auth/isAuthenticated']
    },
    isUserTeacher () {
      return this.$store.getters['user/isUserTeacher']
    }
  },
  data () {
    return {
      activeTab: 0,
      libraries: [
        { 'name': 'd3.js', url: 'libs/d3.js.min' },
        { 'name': 'pixi', url: 'libs/pixi.js.min' },
        { 'name': 'p5.js', url: 'libs/p5.js.min' }
      ],
      name: this.project.name,
      description: this.project.description,
      is_public: this.project.is_public,
      is_shared_with_teacher: true,
      selectedClassroom: this.project.classroom,
      isLoading: false,
      isClassroomStudent: false
    }
  },
  methods: {
    hideSetings: function () {
      console.log('hideSetings')
      this.$store.commit('setEditorConfigProperty', {'isShowingSettings': false})
    },
    saveAndClose: function () {
      this.isLoading = true
      if (!this.$store.getters.getIsProjectOnDb) {
        this.$store.dispatch('createProjectInDbSimple')
          .then((response) => {
            this.onlySaveSettingsAndClose()
              .then(() => {
                this.$router.replace('/editor/' + response.data.id + '/')
              })
          })
      } else {
        this.onlySaveSettingsAndClose()
      }
    },
    onlySaveSettingsAndClose: function () {
      let changes = {'name': this.name, 'description': this.description, 'is_public': this.is_public, 'classroom': this.selectedClassroom}
      this.$store.commit('setProjectProperty', changes)
      return this.$store.dispatch('saveProjectSettings')
        .then(() => {
          this.hideSetings()
        })
        .finally(() => { this.isLoading = false })
    },
    selectClassroom: function (classinfo) {
      this.selectedClassroom = classinfo.id
      this.isClassroomStudent = classinfo.isClassroomStudent
    }
  }
}

</script>

<style lang = "less">
@import (reference) "../../assets/styles/main.less";
#settings-panel {
  width: 70vw;
  max-width:768px;
  margin:auto;

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 50vw;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    margin: 20px 0;
  }

  .modal-default-button {
    float: right;
  }

  /*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    transform: scale(1.1);
  }

  .type {
    display: inline-block;
    background: purple;
    color: white;
    border-radius: 2px;
    padding: 5px 20px;
    margin-left: 0px;
  }

  div.aviso-clase{
    padding:0.75rem 1.5rem;
  }

  .horizontal-chooser {
    display: flex;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Editor/EditorSettings.vue